(function () {
    'use strict';

    angular
        .module('ib-web-ancillaries-services-module')
        .factory('AncillariesPaymentTransformer', AncillariesPaymentTransformer);

    AncillariesPaymentTransformer.$inject = ['localStorageService', 'AncillariesConstants'];
    function AncillariesPaymentTransformer (localStorageService, AncillariesConstants) {
        return {
            createPaymentsRequest: createPaymentsRequest
        };

        ////////////////
        /**
     * Craete payment request for send to service
     * @param {Object} paymentData Data for payment
     * @param {Object} paymentInfo Info for payment
      * @param {Object} selectedLoggedCard Info of selected card logged
     */

        function createPaymentsRequest (paymentData, paymentInfo, selectedLoggedCard) {
            const paymentRequest = {
                flowId: localStorageService.get('bookingInfo').checkinId,
                paymentId: localStorageService.get('paymentMethods').paymentId,
                paymentMethod: {}
            };
            if (paymentData.type === AncillariesConstants.PAYMENT_TYPES.CREDIT_CARD) {
                if (paymentInfo.selectedCard) {
                    paymentRequest.paymentMethod = {
                        type: paymentData.type,
                        cardTypeId: paymentInfo.selectedCard.cardTypeId,
                        profileCardId: null,
                        cardNumber: paymentInfo.creditCardNum,
                        cvv: paymentInfo.cvv,
                        expiration: (paymentInfo.month + paymentInfo.year) + '',
                        payer: {
                            personalInfo: {
                                name: paymentInfo.ownerName,
                                surname: paymentInfo.surnames
                            },
                            contactInfo: {
                                email: paymentInfo.email
                            }, address: {
                                country: paymentInfo.issuerCountry.code
                            }
                        }
                    };
                    if (paymentInfo.zipCode) {
                        paymentRequest.paymentMethod.payer.address.zip = paymentInfo.zipCode;
                    }
                    if (paymentInfo.state && paymentInfo.state.code) {
                        paymentRequest.paymentMethod.payer.address.state = paymentInfo.state.code;
                    }
                    if (paymentInfo.state && paymentInfo.state.description) {
                        paymentRequest.paymentMethod.payer.address.city = paymentInfo.state.description;
                    }
                } else {
                    paymentRequest.paymentMethod = {
                        type: paymentData.type,
                        cardTypeId: selectedLoggedCard.customerInfo.cardTypeId,
                        profileCardId: selectedLoggedCard.customerInfo.profileCardId,
                        cardNumber: selectedLoggedCard.customerInfo.cardNumber,
                        cvv: selectedLoggedCard.paymentInfo.newCvv,
                        expiration: selectedLoggedCard.customerInfo.expiryDate || (selectedLoggedCard.customerInfo.month + selectedLoggedCard.customerInfo.year) + '',
                        payer: {
                            personalInfo: {
                                name: selectedLoggedCard.customerInfo.nameOnCard,
                                surname: selectedLoggedCard.customerInfo.surnameOnCard || selectedLoggedCard.customerInfo.newSurnameOnCard
                            },
                            contactInfo: {
                                email: paymentInfo.email
                            }, address: {
                            }
                        }
                    };
                    if (selectedLoggedCard.customerInfo.profileAddressInfo && selectedLoggedCard.customerInfo.profileAddressInfo.country && selectedLoggedCard.customerInfo.profileAddressInfo.country.code) {
                        paymentRequest.paymentMethod.payer.address.country = selectedLoggedCard.customerInfo.profileAddressInfo.country.code;
                    } else {
                        paymentRequest.paymentMethod.payer.address.country = paymentInfo.issuerCountry.code;
                    }
                    if (selectedLoggedCard.customerInfo.profileAddressInfo.zipCode) {
                        paymentRequest.paymentMethod.payer.address.zip = selectedLoggedCard.customerInfo.profileAddressInfo.zipCode;
                    }
                    if (selectedLoggedCard.customerInfo.profileAddressInfo.state && selectedLoggedCard.customerInfo.profileAddressInfo.state.code) {
                        paymentRequest.paymentMethod.payer.address.state = selectedLoggedCard.customerInfo.profileAddressInfo.state.code;
                    }
                    if (selectedLoggedCard.customerInfo.profileAddressInfo.state && selectedLoggedCard.customerInfo.profileAddressInfo.state.description) {
                        paymentRequest.paymentMethod.payer.address.city = selectedLoggedCard.customerInfo.profileAddressInfo.state.description;
                    }
                }
            }
            return paymentRequest;
        }
    }
})();